<template>
  <div class="text-center" fill-height fluid>
    <v-dialog scrollable v-model="dialog" width="900">
      <template v-slot:activator="{ on, attrs }"></template>

      <v-card>
        <v-card-text class="pt-2 pb-0">
          <v-row>
            <v-col>
              <p class="title success--text">
                1. Peserta Tuntas di Satuan Pendidikan Anda
              </p>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="black--text">No</th>
                      <th class="black--text">UKG</th>
                      <th class="black--text">Nama</th>
                      <th class="black--text">Angkatan</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in items" :key="item.index">
                      <td>{{ index + 1 }}</td>
                      <td class="body-1 purple--text text--darken-3 font-weight-bold">{{ pVal(item.user, "email") }}</td>
                      <td>{{ pVal(item.user, "name") }}</td>
                      <td>{{ pVal(item.kelas, "angkatan") }}</td>
                    </tr>
                  </tbody>
                  <tbody v-if="items.length == 0">
                    <tr>
                      <td colspan="4"><m-alert class="my-2 py-2" show info="Tidak ada GTK tuntas di Satuan Pendidikan Anda"></m-alert></td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
            <v-col cols="12">
              <p class="title success--text">
                2. Syarat untuk mendapatkan Sertifikat
              </p>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="black--text">JENJANG</th>
                      <th class="black--text">Minimal GTK Tuntas</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in itemSyarats" :key="item.index">
                      <td>{{ pVal(item, "jenjang") }}</td>
                      <td>{{ pVal(item, "jumlah") }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <span class="orange--text pt-3"
                >Khusus untuk satuan pendidikan yang masuk dalam daerah <b>3T (Terdepan, Terluar, dan Tertinggal)</b>, dengan batasan minimal GTK yang mengikuti seri Panduan
                Pembelajaran Tahun Ajaran 2021/2022 ini adalah minimal <b>2 GTK (untuk semua jenjang)</b></span
              ></v-col
            >
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="body-1" class="ma-2" text @click="closeGuide">Tutup</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      items: [],
      panel: 0,
      itemSyarats: [
        {
          jenjang: "PAUD",
          jumlah: "2 GTK"
        },
        {
          jenjang: "SD",
          jumlah: "5 GTK"
        },
        {
          jenjang: "SMP/SMA/SMK",
          jumlah: "7 GTK"
        },
        {
          jenjang: "SLB",
          jumlah: "3 GTK"
        }
      ]
    };
  },

  methods: {
    // eslint-disable-next-line
    open() {
      this.items = [];
      this.dialog = true;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
        this.dialog = true;
        this.loadPeserta();
      });
    },
    loadPeserta() {
      return this.$store
        .dispatch("instansi/pesertaTuntas", this.instansi_id)
        .then(res => {
          this.items = res;
        })
        .catch(e => e);
    },
    closeGuide() {
      this.dialog = false;
    }
  }
};
</script>
